import {
  mountBackButton,
  isTMA,
  showBackButton,
  hideBackButton,
  isBackButtonVisible,
  onBackButtonClick,
  offBackButtonClick,
} from '@telegram-apps/sdk-vue'

export default defineNuxtPlugin({
  order: 2,
  name: 'telegramBackButtonWatcher',
  setup() {
    const route = useRoute()
    const router = useRouter()

    if (mountBackButton.isAvailable()) {
      mountBackButton()
    }

    const firstPagePath = ref<string>('')
    const isFirstPage = computed<boolean>(
      () => firstPagePath.value === route.path,
    )

    function backButtonListener() {
      router.back()
    }

    onNuxtReady(() => {
      watch(
        () => route.path,
        () => {
          if (!isTMA()) return
          if (!firstPagePath.value) {
            firstPagePath.value = route.path
            return
          }
          if (isFirstPage.value) {
            hideBackButton()
            offBackButtonClick(backButtonListener)
            return
          }
          if (isBackButtonVisible()) return
          showBackButton()
          onBackButtonClick(backButtonListener)
        },
        {
          immediate: true,
        },
      )
    })
  },
})
